/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { useStoreActions, useStoreState } from '../../reducers';

/**
 *
 */
export default function DriveListPage() {
  /* 
    call getOrgRecordingNum to know whether the organization has private uploaded recording
    if the count > 0, user will be sent to recording page to start with their own recordings
    otherwise, user will go to public data page to view the recording provided by ouster
  */
  const { getOrgRecordingNum } = useStoreActions((actions) => actions.drive);
  const { curUserOrg } = useStoreState((storeState) => ({
    ...storeState.user,
  }));
  const [orgRecordingNum, setOrgRecordingNum] = useState<null | number>(null);

  useEffect(() => {
    const getRecordingCount = async () => {
      if (!curUserOrg?.id) return;
      try {
        const data = await getOrgRecordingNum({ orgId: curUserOrg?.id });
        setOrgRecordingNum(data.count);
      } catch (error) {
        setOrgRecordingNum(0);
      }
    };

    getRecordingCount();
  }, [curUserOrg?.id, getOrgRecordingNum]);

  if (orgRecordingNum === null) return null;

  return (
    <div>
      {orgRecordingNum > 0 ? (
        <Navigate to="/drive/private" />
      ) : (
        <Navigate to="/drive/sample_library" />
      )}
    </div>
  );
}
